module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nfor (var i = 0; i < data.length; i++) {\nif (data[i]) { %>\n\n<a href=\"<%= data[i].href %>\" class=\"link ch-link focusable\"\n   data-fathom=\"<%= data[i].fathom %>\"\n   data-impression=\"<%= data[i].impression %>\"\n   aa-link=\"<%= data[i].aaLink %>\"\n>\n    <div class=\"thumb-wrapper\">\n        <img class=\"thumb lazy loaded\"\n             data-src=\"<%= data[i].filepathPromoTilePosterImage %>\"\n             alt=\"<%= data[i].alt %>\"\n             src=\"<%= data[i].filepathPromoTilePosterImage %>\"\n        />\n\n    </div>\n</a>\n\n<div class=\"break\"></div>\n\n<%  } %>\n<%  } %>"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/carousels/__carouselHubPromotion.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
for (var i = 0; i < data.length; i++) {
if (data[i]) { 
    ; __line = 3
    ; __append("\n\n<a href=\"")
    ; __line = 5
    ; __append(escapeFn( data[i].href ))
    ; __append("\" class=\"link ch-link focusable\"\n   data-fathom=\"")
    ; __line = 6
    ; __append(escapeFn( data[i].fathom ))
    ; __append("\"\n   data-impression=\"")
    ; __line = 7
    ; __append(escapeFn( data[i].impression ))
    ; __append("\"\n   aa-link=\"")
    ; __line = 8
    ; __append(escapeFn( data[i].aaLink ))
    ; __append("\"\n>\n    <div class=\"thumb-wrapper\">\n        <img class=\"thumb lazy loaded\"\n             data-src=\"")
    ; __line = 12
    ; __append(escapeFn( data[i].filepathPromoTilePosterImage ))
    ; __append("\"\n             alt=\"")
    ; __line = 13
    ; __append(escapeFn( data[i].alt ))
    ; __append("\"\n             src=\"")
    ; __line = 14
    ; __append(escapeFn( data[i].filepathPromoTilePosterImage ))
    ; __append("\"\n        />\n\n    </div>\n</a>\n\n<div class=\"break\"></div>\n\n")
    ; __line = 22
    ;   } 
    ; __append("\n")
    ; __line = 23
    ;   } 
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/carousels/__carouselHubPromotion.tpl"

}